const { curry } = require('../functions');

/**
 * OR Combinator
 * Higher order function
 * that executes either fn()
 * or altFn() if fn() turns out falsy
 *
 * @export
 * @param {function} fn - function to be executed
 * @param {function} altFn - function to be executed if fn turns out falsy
 * @returns {function(a)} - func that returns the result of fn OR altFn
 */
exports.or = (fn, altFn) => (a) => fn(a) || altFn(a);

/**
 * S Combinator
 * Higher order function
 * that executes a sequence of given functions independently
 *
 * @export
 * @param {function} ...fn - a set of functions provided as arguments
 * @returns {function(a)} - func that takes an argument that is passed to every given func
 */
exports.seq = function (...funcs) {
  return (a) => funcs.forEach((func) => func(a));
};

/**
 * fork and join
 * Higher order function
 * executes two branches and reunites them afterwards
 *
 * @export
 * @param {function(a: any)} leftFn - first to get executed
 * @param {function(a: any)} rightFn - second to get executed
 * @param {function(res1: any, res2: any)} joinFn - function that calculates the result
 * @returns {function(a)} - func that takes an argument that is passed to left and right
 */
exports.fork = curry(
  (leftFn, rightFn, joinFn) => (a) => joinFn(leftFn(a), rightFn(a))
);
